<template>
          <v-dialog v-model="dialog" width="100%"  style="margin: 100px !important;" persistent class="custom-dialog">
        <v-card>
            <v-card-title>
                <span class="text-h5">
                    Criar Romaneio
                </span>
            </v-card-title>

            <div style="padding: 20px">
                
                <v-row no-gutters style="gap: 15px;">
                    <v-text-field 
                        v-model="romaneio.localCarreg"
                        class="pt-5 pb-5"
                        type="text" 
                        label="Local de Carregamento"
                        chips
                        clearable
                        hide-details
                        outlined
                    ></v-text-field>

                    <v-text-field 
                    v-model="romaneio.respCarreg"
                    class="pt-5 pb-5"
                    type="text"
                    label="Responsável pelo Carregamento"
                    clearable
                    hide-details
                    outlined
                    />

                    <v-text-field 
                        v-model="romaneio.placaVeiculo"
                        class="pt-5 pb-5"
                        type="text"
                        label="Placa do Veículo"
                        clearable
                        hide-details
                        outlined
                    />

                    <v-text-field 
                        v-model="romaneio.placaCarreta"
                        class="pt-5 pb-5"
                        type="text"
                        label="Placa da Carreta"
                        clearable
                        hide-details
                        outlined
                    />

                </v-row>

                <v-row no-gutters style="gap: 15px;">

                    <v-text-field 
                        v-model="romaneio.motNome"
                        class="pt-5 pb-5"
                        type="text"
                        label="Nome do Motorista"
                        clearable
                        hide-details
                        outlined

                    />

                    <v-text-field 
                        v-model="romaneio.motCpf"
                        class="pt-5 pb-5"
                        type="text"
                        label="CPF do Motorista"
                        clearable
                        hide-details
                        outlined
                        v-mask="'###.###.###-##'"
                    />

                    <v-text-field 
                        v-model="romaneio.motRG"
                        class="pt-5 pb-5"
                        type="text"
                        label="RG do Motorista"
                        clearable
                        hide-details
                        outlined
                        v-mask="'##.###.###-#'"
                    />

                    <v-text-field 
                        v-model="romaneio.motCelular"
                        v-mask="'(##) #####-####'"
                        class="pt-5 pb-5"
                        type="text"
                        label="Celular do Motorista"
                        clearable
                        hide-details
                        outlined
                    />

                </v-row>

                <v-row no-gutters style="gap: 15px;">

                    <v-text-field 
                        v-model="romaneio.respReceb"
                        class="pt-5 pb-5"
                        type="text"
                        label="Responsável pelo Recebimento"
                        clearable
                        hide-details
                        outlined
                    />

                    <v-autocomplete 
                        v-model="romaneio.transportadora"
                        class="pt-5 pb-5"
                        type="text"
                        label="Transportadora"
                        clearable
                        hide-details
                        outlined
                        :items="fornecedores"
                        :item-text="'nomeFantasia'"
                        :item-value="'id'"
                    ></v-autocomplete>

                    <v-autocomplete 
                        v-model="romaneio.fornecedor"
                        class="pt-5 pb-5"
                        type="text"
                        label="Fornecedor"
                        clearable
                        hide-details
                        outlined
                        :items="fornecedores"
                        :item-text="'nomeFantasia'"
                        :item-value="'id'"
                    ></v-autocomplete>

                    <vuetify-money
                        v-model="romaneio.vlrTotal"
                        class="pt-5 pb-5"
                        type="number"
                        label="Valor Total"
                        clearable
                        hide-details
                        outlined
                    />


                </v-row>

                <v-row no-gutters style="gap: 15px;">

                    <v-combobox 
                        v-model="romaneio.tipoFrete"
                        :items="tipoFreteOptions"
                        class="pt-5 pb-5"
                        type="text"
                        label="Tipo de Frete"
                        clearable
                        hide-details
                        outlined
                    />

                    <v-text-field 
                        v-model="romaneio.quantidade"
                        class="pt-5 pb-5"
                        type="number"
                        label="Quantidade"
                        clearable
                        hide-details
                        outlined
                    />

                    <v-text-field 
                        v-model="romaneio.especie"
                        class="pt-5 pb-5"
                        type="text"
                        label="Espécie"
                        clearable
                        hide-details
                        outlined
                    />

                    <v-text-field 
                        v-model="romaneio.marca"
                        class="pt-5 pb-5"
                        type="text"
                        label="Marca"
                        clearable
                        hide-details
                        outlined
                    />
                </v-row>

                <v-row no-gutters style="gap: 15px;">

                    <v-text-field 
                        v-model="romaneio.numeracao"
                        class="pt-5 pb-5"
                        type="text"
                        label="Numeração"
                        clearable
                        hide-details
                        outlined
                    />

                    <v-text-field 
                        v-model="romaneio.pesoBruto"
                        class="pt-5 pb-5"
                        type="number"
                        label="Peso Bruto"
                        clearable
                        hide-details
                        outlined
                    />

                    <v-text-field 
                        v-model="romaneio.pesoLiquido"
                        class="pt-5 pb-5"
                        type="number"
                        label="Peso Líquido"
                        clearable
                        hide-details
                        outlined
                    />
                </v-row>

                <v-row no-gutters style="gap: 15px;">
                    <v-textarea 
                        v-model="romaneio.multaObs"
                        class="pt-5 pb-5"
                        type="text"
                        label="Observações/Multa"
                        clearable
                        hide-details
                        outlined
                    />
                </v-row>
                
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>Status</th>
                            <th>Desceção</th>
                            <th>Data</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in itemsSelected" :key="index">
                            <td class="pa-5">
                                {{  item.codigo }}
                            </td>
                            <td>
                                {{ item.status }}
                            </td>
                            <td class="pa-5">
                                {{ item.descricao }}
                            </td>
                            <td class="pa-5">
                                {{ item.dataCriacao ? new Date(item.dataCriacao).toLocaleDateString() : "Não informado" }}
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>


            </div>
            
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="$emit('close')">
                    Cancelar
                </v-btn>
                
                <v-btn color="blue darken-1" text @click="saveRomaneio">
                    Confirmar
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>

import {VMoney} from 'v-money'
import Vue from 'vue';

export default {
    name: 'CreateRomaneioView',
    props: ['open', 'itemsSelected'],
    directives: { money: VMoney }, 
    data() {
        return {
            dialog: false,
            money: {
                locale: "pt-br",
                length: 11,
                precision: this.precision || 2,
                masked: false
            },
            tipoFreteOptions: [
                "CIF Cost, Insurance and Freight - vendedor paga frete e seguro até o porto de destino, mas o risco transfere no embarque.",
                "FOB Free on Board - vendedor entrega no porto de embarque; comprador assume custos e riscos do transporte.",
                "CFR Cost and Freight - vendedor paga o frete até o destino, mas sem o seguro.",
                "EXW Ex Works - vendedor só disponibiliza a mercadoria em sua fábrica/deposito; comprador assume tudo.",
                "FCA Free Carrier - vendedor entrega a mercadoria a um transportador designado pelo comprador.",
                "FAS Free Alongside Ship - vendedor entrega a mercadoria ao lado do navio no porto de embarque.",
                "CPT Carriage Paid To - vendedor paga o frete até o destino combinado, sem seguro.",
                "CIP Carriage and Insurance Paid To - vendedor paga frete + seguro até o destino combinado.",
                "DAP Delivered at Place - vendedor entrega no local do comprador, mas sem pagar desembaraço aduaneiro.",
                "DPU Delivered at Place Unloaded - vendedor entrega no local combinado já com a descarga feita.",
                "DDP Delivered Duty Paid - vendedor entrega no local do comprador, já com impostos e desembaraço pagos."
            ],
            fornecedores: [],
            romaneio: {
                localCarreg: '',
                respCarreg: '',
                placaVeiculo: '',
                placaCarreta: '',
                motNome: '',
                motCpf: '',
                motRG: '',
                motCelular: '',
                respReceb: '',
                vlrTotal: 0,
                transportadora: '',
                fornecedor: '',
                tipoFrete: '',
                quantidade: 0,
                especie:'',
                marca: '',
                numeracao: '',
                pesoBruto: '',
                pesoLiquido: '',
                multaObs: '',
            }
        }
    },
    methods: {
        saveRomaneio() {
            this.$emit('save', this.romaneio);
        },

        async getFornecedores(){
            const response = await Vue.prototype.$http.get('/Entity/Fornecedor', {
                params: {
                    page: 1,
                    limit: 9999
                }
            })
            this.fornecedores = response.data.data.data
        }
    },

    watch: {
        open(value){
            this.dialog = value
        }
    },

    async created() {
        await this.getFornecedores();
    }


}
</script>

<style>

</style>